(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[735],{

/***/ 5192:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ ForwardRef; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(2784);
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgClock = function SvgClock(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM13 7C13 6.44772 12.5523 6 12 6C11.4477 6 11 6.44772 11 7V12C11 12.2652 11.1054 12.5196 11.2929 12.7071L14.2929 15.7071C14.6834 16.0976 15.3166 16.0976 15.7071 15.7071C16.0976 15.3166 16.0976 14.6834 15.7071 14.2929L13 11.5858V7Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(SvgClock);

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00IDEyQzQgNy41ODE3MiA3LjU4MTcyIDQgMTIgNEMxNi40MTgzIDQgMjAgNy41ODE3MiAyMCAxMkMyMCAxNi40MTgzIDE2LjQxODMgMjAgMTIgMjBDNy41ODE3MiAyMCA0IDE2LjQxODMgNCAxMlpNMTIgMkM2LjQ3NzE1IDIgMiA2LjQ3NzE1IDIgMTJDMiAxNy41MjI4IDYuNDc3MTUgMjIgMTIgMjJDMTcuNTIyOCAyMiAyMiAxNy41MjI4IDIyIDEyQzIyIDYuNDc3MTUgMTcuNTIyOCAyIDEyIDJaTTEzIDdDMTMgNi40NDc3MiAxMi41NTIzIDYgMTIgNkMxMS40NDc3IDYgMTEgNi40NDc3MiAxMSA3VjEyQzExIDEyLjI2NTIgMTEuMTA1NCAxMi41MTk2IDExLjI5MjkgMTIuNzA3MUwxNC4yOTI5IDE1LjcwNzFDMTQuNjgzNCAxNi4wOTc2IDE1LjMxNjYgMTYuMDk3NiAxNS43MDcxIDE1LjcwNzFDMTYuMDk3NiAxNS4zMTY2IDE2LjA5NzYgMTQuNjgzNCAxNS43MDcxIDE0LjI5MjlMMTMgMTEuNTg1OFY3WiIvPgo8L3N2Zz4K");

/***/ }),

/***/ 71285:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E6": function() { return /* binding */ GetBlogPostBySlugTagsFragmentFragmentDoc; },
/* harmony export */   "FD": function() { return /* binding */ GetBlogPostBySlugImageFragmentFragmentDoc; },
/* harmony export */   "Mq": function() { return /* binding */ GetBlogCategoriesPaginationFragmentFragmentDoc; },
/* harmony export */   "Wj": function() { return /* binding */ GetBlogPostBySlugCategoryFragmentFragmentDoc; },
/* harmony export */   "XI": function() { return /* binding */ GetBlogCategoriesDataFragmentFragmentDoc; },
/* harmony export */   "mS": function() { return /* binding */ GetBlogCategoriesPostPaginationFragmentFragmentDoc; },
/* harmony export */   "mW": function() { return /* binding */ GetBlogPostBySlugSeoFragmentFragmentDoc; },
/* harmony export */   "s_": function() { return /* binding */ GetBlogPostBySlugAuthorFragmentFragmentDoc; }
/* harmony export */ });
/* unused harmony exports GetBlogPostBySlugMetaFormatsFragmentFragmentDoc, GetBlogPostBySlugMetaSocialFragmentFragmentDoc, GetBlogPostBySlugOverwrittenImagesFragmentFragmentDoc, GetBlogCategoriesPostFragmentFragmentDoc */
/* eslint-disable */ // @ts-nocheck
const GetBlogPostBySlugMetaFormatsFragmentFragmentDoc = "\n    fragment GetBlogPostBySlugMetaFormatsFragment on Media {\n  formats {\n    large {\n      height\n      mime\n      url\n      width\n    }\n    medium {\n      height\n      mime\n      url\n      width\n    }\n    small {\n      height\n      mime\n      url\n      width\n    }\n    thumbnail {\n      height\n      mime\n      url\n      width\n    }\n  }\n}\n    ";
const GetBlogPostBySlugMetaSocialFragmentFragmentDoc = /*#__PURE__*/ "\n    fragment GetBlogPostBySlugMetaSocialFragment on MetaSocial {\n  image {\n    alternativeText\n    ...GetBlogPostBySlugMetaFormatsFragment\n    height\n    mime\n    url\n    width\n  }\n}\n    ".concat(GetBlogPostBySlugMetaFormatsFragmentFragmentDoc);
const GetBlogPostBySlugSeoFragmentFragmentDoc = /*#__PURE__*/ "\n    fragment GetBlogPostBySlugSeoFragment on FullPostAttributes {\n  seo {\n    id\n    keywords\n    metaDescription\n    metaSocial {\n      description\n      id\n      ...GetBlogPostBySlugMetaSocialFragment\n      title\n    }\n    metaTitle\n  }\n}\n    ".concat(GetBlogPostBySlugMetaSocialFragmentFragmentDoc);
const GetBlogPostBySlugTagsFragmentFragmentDoc = "\n    fragment GetBlogPostBySlugTagsFragment on FullPostAttributes {\n  tags {\n    name\n  }\n}\n    ";
const GetBlogPostBySlugOverwrittenImagesFragmentFragmentDoc = "\n    fragment GetBlogPostBySlugOverwrittenImagesFragment on Media {\n  formats {\n    overwrittenLarge {\n      url\n    }\n    overwrittenMedium {\n      url\n    }\n    overwrittenSmall {\n      url\n    }\n    overwrittenThumbnail {\n      url\n    }\n  }\n}\n    ";
const GetBlogPostBySlugImageFragmentFragmentDoc = /*#__PURE__*/ "\n    fragment GetBlogPostBySlugImageFragment on FullPostAttributes {\n  featuredImage {\n    authorName\n    authorPortfolio\n    image {\n      url\n      ...GetBlogPostBySlugOverwrittenImagesFragment\n    }\n    siteLink\n    siteOfImage\n  }\n}\n    ".concat(GetBlogPostBySlugOverwrittenImagesFragmentFragmentDoc);
const GetBlogPostBySlugCategoryFragmentFragmentDoc = "\n    fragment GetBlogPostBySlugCategoryFragment on FullPostAttributes {\n  category {\n    name\n  }\n}\n    ";
const GetBlogPostBySlugAuthorFragmentFragmentDoc = "\n    fragment GetBlogPostBySlugAuthorFragment on FullPostAttributes {\n  authors {\n    name\n    picture {\n      url\n    }\n  }\n}\n    ";
const GetBlogCategoriesPaginationFragmentFragmentDoc = "\n    fragment GetBlogCategoriesPaginationFragment on CategoryWithPostsAttributesData {\n  pagination {\n    page\n    pageCount\n    pageSize\n    total\n  }\n}\n    ";
const GetBlogCategoriesPostPaginationFragmentFragmentDoc = "\n    fragment GetBlogCategoriesPostPaginationFragment on CategoryWithPostsAttributes {\n  postsPagination {\n    page\n    pageCount\n    pageSize\n    total\n  }\n}\n    ";
const GetBlogCategoriesPostFragmentFragmentDoc = /*#__PURE__*/ "\n    fragment GetBlogCategoriesPostFragment on CategoryWithPostsAttributes {\n  posts {\n    id\n    title\n  }\n  ...GetBlogCategoriesPostPaginationFragment\n}\n    ".concat(GetBlogCategoriesPostPaginationFragmentFragmentDoc);
const GetBlogCategoriesDataFragmentFragmentDoc = /*#__PURE__*/ "\n    fragment GetBlogCategoriesDataFragment on CategoryWithPostsAttributesData {\n  data {\n    name\n    id\n    ...GetBlogCategoriesPostFragment\n  }\n}\n    ".concat(GetBlogCategoriesPostFragmentFragmentDoc);


/***/ }),

/***/ 69565:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Vp": function() { return /* binding */ Tag; }
/* harmony export */ });
/* unused harmony export TagVariants */
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(36904);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);



var TagVariants;
(function(TagVariants) {
    TagVariants["Brand"] = "brand";
    TagVariants["Highlight"] = "highlight";
    TagVariants["Success"] = "success";
    TagVariants["Warning"] = "warning";
    TagVariants["Error"] = "error";
    TagVariants["Neutral"] = "neutral";
    TagVariants["NeutralLight"] = "neutral-light";
})(TagVariants || (TagVariants = {}));
const Tag = (param)=>{
    let { label , className , labelClassName ="" , icon , size ="medium" , variant =TagVariants.Brand  } = param;
    const Icon = icon;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_1___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().tag), (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[size], (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[variant], className),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Icon, {
                className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().icon)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: labelClassName,
                children: label
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["ZP"] = (Tag);


/***/ }),

/***/ 82185:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "o": function() { return /* binding */ websiteFormatArticleList; }
/* harmony export */ });
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(76854);
/* harmony import */ var slugify__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(slugify__WEBPACK_IMPORTED_MODULE_0__);

const websiteFormatArticleList = (articleList)=>{
    if (!(articleList === null || articleList === void 0 ? void 0 : articleList.length)) {
        return [];
    }
    return articleList === null || articleList === void 0 ? void 0 : articleList.map((article)=>{
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
        const categoryName = slugify__WEBPACK_IMPORTED_MODULE_0___default()((article === null || article === void 0 ? void 0 : (ref = article.category) === null || ref === void 0 ? void 0 : ref.name) || "", {
            lower: true
        });
        const featuredImage = article === null || article === void 0 ? void 0 : (ref1 = article.featuredImage) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.image) === null || ref2 === void 0 ? void 0 : ref2.url;
        const overwrittenThumbnailImage = (article === null || article === void 0 ? void 0 : (ref3 = article.featuredImage) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.image) === null || ref4 === void 0 ? void 0 : (ref5 = ref4.formats) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.overwrittenThumbnail) === null || ref6 === void 0 ? void 0 : ref6.url) || "";
        return {
            id: (article === null || article === void 0 ? void 0 : article.id) || "",
            title: (article === null || article === void 0 ? void 0 : article.title) || "",
            href: "/blog/".concat(categoryName, "/").concat(article === null || article === void 0 ? void 0 : article.slug),
            resume: (article === null || article === void 0 ? void 0 : article.resume) || "",
            picture: featuredImage || overwrittenThumbnailImage,
            createdAt: article === null || article === void 0 ? void 0 : article.createdAt,
            readingTime: article === null || article === void 0 ? void 0 : article.readingTime,
            categoryName: (article === null || article === void 0 ? void 0 : (ref7 = article.category) === null || ref7 === void 0 ? void 0 : ref7.name) || ""
        };
    });
};


/***/ }),

/***/ 34792:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w": function() { return /* binding */ ArticleList; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react-waypoint/es/index.js + 2 modules
var es = __webpack_require__(10196);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/next/image.js
var next_image = __webpack_require__(96577);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
;// CONCATENATED MODULE: ../../libs/ui-kit/src/lib/assets/icons/file-text-filled.svg
var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }


var SvgFileTextFilled = function SvgFileTextFilled(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/react.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/react.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 2H13V7C13 7.53043 13.2107 8.03914 13.5858 8.41421C13.9609 8.78929 14.4696 9 15 9H20V19C20 19.7957 19.6839 20.5587 19.1213 21.1213C18.5587 21.6839 17.7957 22 17 22H7C6.20435 22 5.44129 21.6839 4.87868 21.1213C4.31607 20.5587 4 19.7957 4 19V5C4 4.20435 4.31607 3.44129 4.87868 2.87868C5.44129 2.31607 6.20435 2 7 2ZM15 2.58579L19.4142 7H15V2.58579ZM9 8C8.44772 8 8 8.44772 8 9C8 9.55228 8.44772 10 9 10H10C10.5523 10 11 9.55228 11 9C11 8.44772 10.5523 8 10 8H9ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H15C15.5523 14 16 13.5523 16 13C16 12.4477 15.5523 12 15 12H9ZM8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z"
  })));
};
var ForwardRef = /*#__PURE__*/(0,react.forwardRef)(SvgFileTextFilled);

/* harmony default export */ var file_text_filled = ("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik03IDJIMTNWN0MxMyA3LjUzMDQzIDEzLjIxMDcgOC4wMzkxNCAxMy41ODU4IDguNDE0MjFDMTMuOTYwOSA4Ljc4OTI5IDE0LjQ2OTYgOSAxNSA5SDIwVjE5QzIwIDE5Ljc5NTcgMTkuNjgzOSAyMC41NTg3IDE5LjEyMTMgMjEuMTIxM0MxOC41NTg3IDIxLjY4MzkgMTcuNzk1NyAyMiAxNyAyMkg3QzYuMjA0MzUgMjIgNS40NDEyOSAyMS42ODM5IDQuODc4NjggMjEuMTIxM0M0LjMxNjA3IDIwLjU1ODcgNCAxOS43OTU3IDQgMTlWNUM0IDQuMjA0MzUgNC4zMTYwNyAzLjQ0MTI5IDQuODc4NjggMi44Nzg2OEM1LjQ0MTI5IDIuMzE2MDcgNi4yMDQzNSAyIDcgMlpNMTUgMi41ODU3OUwxOS40MTQyIDdIMTVWMi41ODU3OVpNOSA4QzguNDQ3NzIgOCA4IDguNDQ3NzIgOCA5QzggOS41NTIyOCA4LjQ0NzcyIDEwIDkgMTBIMTBDMTAuNTUyMyAxMCAxMSA5LjU1MjI4IDExIDlDMTEgOC40NDc3MiAxMC41NTIzIDggMTAgOEg5Wk05IDEyQzguNDQ3NzIgMTIgOCAxMi40NDc3IDggMTNDOCAxMy41NTIzIDguNDQ3NzIgMTQgOSAxNEgxNUMxNS41NTIzIDE0IDE2IDEzLjU1MjMgMTYgMTNDMTYgMTIuNDQ3NyAxNS41NTIzIDEyIDE1IDEySDlaTTggMTdDOCAxNi40NDc3IDguNDQ3NzIgMTYgOSAxNkgxNUMxNS41NTIzIDE2IDE2IDE2LjQ0NzcgMTYgMTdDMTYgMTcuNTUyMyAxNS41NTIzIDE4IDE1IDE4SDlDOC40NDc3MiAxOCA4IDE3LjU1MjMgOCAxN1oiLz4KPC9zdmc+Cg==");
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/assets/icons/clock.svg
var clock = __webpack_require__(5192);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/tag/index.tsx
var components_tag = __webpack_require__(69565);
// EXTERNAL MODULE: ../../libs/ui-kit/src/lib/components/link/link.tsx
var link_link = __webpack_require__(946);
// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/article-card/index.module.scss
var index_module = __webpack_require__(81158);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/blog/article-card/index.tsx






const ArticleCard = (param)=>{
    let { className , picture , title , description , minutesRead , tag , href , as ="p"  } = param;
    const CustomArticleTitleTag = "".concat(as);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((index_module_default())["article-card"], className),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (index_module_default())["picture-wrapper"],
                children: picture ? /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    className: (index_module_default()).picture,
                    src: picture,
                    alt: "The ".concat(title, "'s article card"),
                    priority: true,
                    fill: true,
                    sizes: "100vw"
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(ForwardRef, {
                    className: (index_module_default())["picture-icon"]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: (index_module_default())["text-wrapper"],
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classnames_default()((index_module_default())["time-read-container"], {
                            [(index_module_default())["container-with-tag"]]: tag
                        }),
                        children: [
                            tag && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tag/* Tag */.Vp, {
                                label: tag,
                                className: (index_module_default())["article-tag"]
                            }),
                            tag && /*#__PURE__*/ (0,jsx_runtime.jsx)(components_tag/* Tag */.Vp, {
                                label: tag,
                                size: "small",
                                className: (index_module_default())["article-tag-small"]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                className: (index_module_default())["min-read"],
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(clock/* ReactComponent */.r, {
                                        className: (index_module_default())["clock-icon"]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        children: [
                                            minutesRead,
                                            " min read"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomArticleTitleTag, {
                        className: (index_module_default()).title,
                        title: title,
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (index_module_default()).description,
                        title: description,
                        children: description
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(link_link/* Link */.rU, {
                href: href,
                className: (index_module_default())["clickable-area"],
                "aria-label": title,
                prefetch: false
            })
        ]
    });
};
/* harmony default export */ var article_card = ((/* unused pure expression or super */ null && (ArticleCard)));

// EXTERNAL MODULE: ../../libs/website-components/src/lib/components/blog/article-list/styles.module.scss
var styles_module = __webpack_require__(23358);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ../../libs/website-components/src/lib/components/blog/article-list/index.tsx





const ArticleList = (param)=>{
    let { posts , onLoadMore , className , hideThirdCard =false , hideCategoryTag =false  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
        className: classnames_default()((styles_module_default())["article-list"], className),
        children: posts.map((post, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                className: classnames_default()({
                    [(styles_module_default())["card-item"]]: hideThirdCard
                }),
                children: [
                    index === posts.length - 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(es/* Waypoint */.h, {
                        onEnter: onLoadMore
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleCard, {
                        tag: hideCategoryTag ? null : post.categoryName,
                        href: post.href,
                        title: post.title,
                        description: post.resume,
                        picture: post.picture,
                        minutesRead: post.readingTime
                    })
                ]
            }, "post-".concat(post.title)))
    });
};


/***/ }),

/***/ 25352:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ WebsiteSeo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(55351);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5632);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);



const WebsiteSeo = (param)=>{
    let { seo  } = param;
    const websiteUrl = "https://olby.com";
    const { asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    const asPathWithoutParams = asPath.split("?")[0];
    const canonical = websiteUrl + asPathWithoutParams;
    const websiteSeo = {
        canonical,
        ...seo
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .NextSeo */ .PB, {
        ...websiteSeo
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (WebsiteSeo);


/***/ }),

/***/ 36904:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag":"tag_tag__Fh9gO","brand":"tag_brand__q09Pc","theme--light":"tag_theme--light__dMD2D","theme--dark":"tag_theme--dark__XLLnc","icon":"tag_icon__jgp8r","highlight":"tag_highlight__P3xm9","success":"tag_success__ZESS9","warning":"tag_warning__o3y4Y","error":"tag_error__U1Dr_","neutral":"tag_neutral__BCxKl","neutral-light":"tag_neutral-light__wL5Ut","small":"tag_small__YiJJF","medium":"tag_medium__WR77R","fade-in-up":"tag_fade-in-up__MkoAH","fade-in-opacity":"tag_fade-in-opacity__LemvY","fade-in-up-opacity":"tag_fade-in-up-opacity__ndK55","fade-out-opacity":"tag_fade-out-opacity__0dzpe","fade-out-left":"tag_fade-out-left__bnBJQ"};

/***/ }),

/***/ 81158:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-card":"article-card_article-card___vTCL","theme--light":"article-card_theme--light__7IAsk","theme--dark":"article-card_theme--dark__qW_7X","picture-wrapper":"article-card_picture-wrapper__WN65_","picture":"article-card_picture__fNrpQ","picture-icon":"article-card_picture-icon__pVJJ6","text-wrapper":"article-card_text-wrapper__Zj1yZ","time-read-container":"article-card_time-read-container__zSFmT","container-with-tag":"article-card_container-with-tag__2U3sf","article-tag":"article-card_article-tag__5bXak","article-tag-small":"article-card_article-tag-small__CXpVy","min-read":"article-card_min-read__igzEY","clock-icon":"article-card_clock-icon__w5N7h","title":"article-card_title__XfyDd","description":"article-card_description__bmbrR","clickable-area":"article-card_clickable-area__Aj5gC","fade-in-up":"article-card_fade-in-up__MOfUX","fade-in-opacity":"article-card_fade-in-opacity__hVsR5","fade-in-up-opacity":"article-card_fade-in-up-opacity__KLnMO","fade-out-opacity":"article-card_fade-out-opacity__E4RUn","fade-out-left":"article-card_fade-out-left__g6GlF"};

/***/ }),

/***/ 23358:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"article-list":"styles_article-list__V3BpG","card-item":"styles_card-item__yJeba","fade-in-up":"styles_fade-in-up__PxEHQ","fade-in-opacity":"styles_fade-in-opacity__BpZaT","fade-in-up-opacity":"styles_fade-in-up-opacity__FdaAc","fade-out-opacity":"styles_fade-out-opacity__hSoG_","fade-out-left":"styles_fade-out-left__A3teE"};

/***/ })

}]);